import React, { useEffect, useState } from 'react';
import { Button, Icon, Input, Loader } from 'semantic-ui-react';
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import axios from 'axios';
import GConf from '../../AssetsM/generalConf';
import { toast } from 'react-toastify';
import { NavLink } from 'react-router-dom';

const EditCard = ({toEditProject,setToeditProject}) => {
        const [addProjectDate , setAddPD] = useState({})

        const EditProject = () => {
            
            if (!toEditProject.P_ID) {toast.error("Matricule Invalide !", GConf.TostErrorGonf)}
            else if (!toEditProject.P_ID) {toast.error("Nom Invalide !", GConf.TostErrorGonf)}
            else if (!toEditProject.P_ID) {toast.error("Phone Invalide !", GConf.TostErrorGonf)}
            else if (!toEditProject.P_ID) {toast.error("Nom Sociale  Invalide !", GConf.TostErrorGonf)}
            else if (!toEditProject.P_ID) {toast.error("Gouvernorat Invalide !", GConf.TostErrorGonf)}
            else if (!toEditProject.P_ID) {toast.error("Delegation Invalide !", GConf.TostErrorGonf)}
            else if (!toEditProject.P_ID) {toast.error("Adresee Invalide !", GConf.TostErrorGonf)}
            else{
                 
                axios.post(`${GConf.ApiLink}/houssem/project/update`, {
                    projectData : toEditProject, 
                }).then(function (response) {
                     console.log(response.data)
                }).catch((error) => {
                     console.log(error)
                });
                        
            }
        }
        const DeletProject = (Pid) => {
                axios.post(`${GConf.ApiLink}/houssem/project/delete`, {
                    P_ID : Pid, 
                }).then(function (response) {
                     console.log(response.data)
                }).catch((error) => {
                     console.log(error)
                });
 
        }
        return(<>
                <div className='row'>
                   <div className='col-12 col-lg-5'>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_Name :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={toEditProject.P_Name}     onChange={(e) => setToeditProject({...toEditProject, P_Name: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_Description :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={toEditProject.P_Description}     onChange={(e) => setToeditProject({...toEditProject, P_Description: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_Month_Income :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={toEditProject.P_Month_Income}     onChange={(e) => setToeditProject({...toEditProject, P_Month_Income: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_Year_Income :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={toEditProject.P_Year_Income}     onChange={(e) => setToeditProject({...toEditProject, P_Year_Income: e.target.value })}/>
                        </div>
                        

                   </div> 
                   <div className='col-12 col-lg-5'>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_Start_Cost :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={toEditProject.P_Start_Cost}     onChange={(e) => setToeditProject({...addProjectDate, P_Start_Cost: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_Month_Cost :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={toEditProject.P_Month_Cost}     onChange={(e) => setToeditProject({...toEditProject, P_Month_Cost: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_Start_Date :</h5>
                            <Input icon='key' type='date' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={toEditProject.P_Start_Date}     onChange={(e) => setToeditProject({...toEditProject, P_Start_Date: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_State :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={toEditProject.P_State}     onChange={(e) => setToeditProject({...toEditProject, P_State: e.target.value })}/>
                        </div>
                        <div className='text-end mb-5'>
                            <Button  onClick={() => EditProject()}   className='text-end rounded-pill bg-system-btn ' positive>  <Icon name='save outline' /> Save    </Button>
                        </div>
                   </div>
                    <div className='col-12 col-lg-2'>
                        <div className='text-end mb-5'>
                            <Button fluid  onClick={() => DeletProject(toEditProject.P_ID)}   className='  rounded-pill bg-system-btn ' positive>  <Icon name='save outline' /> Supprimer     </Button>
                        </div>
                   </div>
                   
                </div>
        </>)
    }

function HoussemMainPage() {
    const defaultProjects = [
        {P_ID:1, P_Name:'منصة أبيض ', P_Description :'', P_Month_Income: 209 , P_Year_Income: 2500, P_Start_Date:'10-05-2018', P_Start_Cost:5000, P_Month_Cost: 150 ,  P_State:'Building'},
        {P_ID:1, P_Name:'دروس خصوصية', P_Description :'', P_Month_Income: 150 , P_Year_Income: 1350, P_Start_Date:'10-09-2025', P_Start_Cost:5000, P_Month_Cost: 50 ,  P_State:'Building'},
        {P_ID:1, P_Name:'منزل للكراء', P_Description :'', P_Month_Income: 300 , P_Year_Income: 2700, P_Start_Date:'10-09-2025', P_Start_Cost:5000, P_Month_Cost: 10 ,  P_State:'Building'},
        {P_ID:1, P_Name:'vending machine', P_Description :'', P_Month_Income: 500 , P_Year_Income: 6000 , P_Start_Date:'10-09-2025', P_Start_Cost:5000, P_Month_Cost: 200 ,  P_State:'Building'},
        {P_ID:1, P_Name:'مشروع فلاحي', P_Description :'', P_Month_Income: 1000 , P_Year_Income: 9000 , P_Start_Date:'10-09-2025', P_Start_Cost:5000, P_Month_Cost: 400 ,  P_State:'Building'},
    ]
    let [projectListe, setProjectListe] = useState(defaultProjects)
    const [openD, setOpenD] = useState(false)
    let [activeIndex, setActiveIndex] = useState('add')
    let [totaleMonth, setTotaleMonth] = useState(0)
    let [totalYear, setTotalYears] = useState(0)
    let [toEditProject, setToeditProject] = useState({})

    useEffect(()=>{
         axios.post(`${GConf.ApiLink}/houssem/projects`, {
            PID : 1, 
        }).then(function (response) {
                console.log(response.data)
                setProjectListe(response.data)
        }).catch((error) => {
                console.log(error)
        });

        let yrs = 0
        let mth = 0
        defaultProjects.map((data) => {
            yrs = yrs + (data.P_Year_Income - (12* data.P_Month_Cost));
            mth = mth + (data.P_Month_Income - data.P_Month_Cost);
        })
        setTotalYears(yrs.toFixed(3))
        setTotaleMonth(mth.toFixed(3))
    },[])

    const AddCard = () => {
        const [addProjectDate , setAddPD] = useState({})

        const SaveProject = () => {
            
            if (!addProjectDate.P_Name) {toast.error("Matricule Invalide !", GConf.TostErrorGonf)}
            else if (!addProjectDate.P_Month_Income) {toast.error("Nom Invalide !", GConf.TostErrorGonf)}
            else if (!addProjectDate.P_Description) {toast.error("Phone Invalide !", GConf.TostErrorGonf)}
            else if (!addProjectDate.P_Name) {toast.error("Nom Sociale  Invalide !", GConf.TostErrorGonf)}
            else if (!addProjectDate.P_Name) {toast.error("Gouvernorat Invalide !", GConf.TostErrorGonf)}
            else if (!addProjectDate.P_Name) {toast.error("Delegation Invalide !", GConf.TostErrorGonf)}
            else if (!addProjectDate.P_Name) {toast.error("Adresee Invalide !", GConf.TostErrorGonf)}
            else{
                 
                axios.post(`${GConf.ApiLink}/houssem/project/insert`, {
                    projectData : addProjectDate, 
                }).then(function (response) {
                     console.log(response.data)
                }).catch((error) => {
                     console.log(error)
                });
                        
            }
        }

        return(<>
                <div className='row'>
                   <div className='col-6'>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_Name :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='Nom' className='w-100 border-0 shadow-sm rounded mb-1' value={addProjectDate.P_Name}     onChange={(e) => setAddPD({...addProjectDate, P_Name: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_Description :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='P_Description' className='w-100 border-0 shadow-sm rounded mb-1' value={addProjectDate.P_Description}  onChange={(e) => setAddPD({...addProjectDate, P_Description: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_Month_Income :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='P_Month_Income' className='w-100 border-0 shadow-sm rounded mb-1' value={addProjectDate.P_Month_Income}  onChange={(e) => setAddPD({...addProjectDate, P_Month_Income: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_Year_Income :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='P_Year_Income' className='w-100 border-0 shadow-sm rounded mb-1' value={addProjectDate.P_Year_Income}  onChange={(e) => setAddPD({...addProjectDate, P_Year_Income: e.target.value })}/>
                        </div>
                        

                   </div> 
                   <div className='col-6'>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_Start_Cost :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='P_Start_Cost' className='w-100 border-0 shadow-sm rounded mb-1' value={addProjectDate.P_Start_Cost}  onChange={(e) => setAddPD({...addProjectDate, P_Start_Cost: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_Month_Cost :</h5>
                            <Input icon='key' iconPosition='left'  placeholder='P_Month_Cost' className='w-100 border-0 shadow-sm rounded mb-1' value={addProjectDate.P_Month_Cost}  onChange={(e) => setAddPD({...addProjectDate, P_Month_Cost: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_Start_Date :</h5>
                            <Input icon='key' type='date' iconPosition='left'  placeholder='P_Start_Date' className='w-100 border-0 shadow-sm rounded mb-1' value={addProjectDate.P_Start_Date}  onChange={(e) => setAddPD({...addProjectDate, P_Start_Date: e.target.value })}/>
                        </div>
                        <div className='p-1 mb-2'>
                            <h5 className='mb-1'> P_State :</h5>
                            <Input icon='key'  iconPosition='left'  placeholder='P_State' className='w-100 border-0 shadow-sm rounded mb-1' value={addProjectDate.P_State}  onChange={(e) => setAddPD({...addProjectDate, P_State: e.target.value })}/>
                        </div>
                   </div>
                   <div className='text-end mb-5'>
                        <Button  onClick={() => SaveProject()}   className='text-end rounded-pill bg-system-btn ' positive>  <Icon name='save outline' /> Save    </Button>
                    </div>
                </div>
        </>)
    }

    

    const OpenBottomSheet = (genre,Data) => {
        setActiveIndex(genre)
        setOpenD(!openD)
        if (Data && genre == 'edit') {
            setToeditProject(Data)
        }
    }

    return ( <>
        <div className='container-fluid mt-4' dir='rtl'>
            <div className='text-center'><h1>  بسم اللله الرحمان الرحيم   </h1></div>
            <br />
             <div className='row'>
                <div className='mb-4'>
                    <Button basic onClick={() => OpenBottomSheet('add')} color='red'> Ajouter </Button>
                    {/* <Button basic onClick={() => OpenBottomSheet('edit')} color='orange'> Modifier </Button> */}
                    {/* <Button basic onClick={() => OpenBottomSheet('add')} color='yellow'> Yellow </Button>
                    <Button basic onClick={() => OpenBottomSheet('add')} color='olive'> Olive </Button>
                    <Button basic onClick={() => OpenBottomSheet('add')} color='green'> Green </Button>
                    <Button basic onClick={() => OpenBottomSheet('add')} color='teal'> Teal </Button>
                    <Button basic onClick={() => OpenBottomSheet('add')} color='blue'> Blue </Button>
                    <Button basic onClick={() => OpenBottomSheet('add')} color='violet'> Violet </Button>
                    <Button basic onClick={() => OpenBottomSheet('add')} color='purple'> Purple </Button>
                    <Button basic onClick={() => OpenBottomSheet('add')} color='pink'> Pink </Button>
                    <Button basic onClick={() => OpenBottomSheet('add')} color='brown'> Brown </Button>
                    <Button basic onClick={() => OpenBottomSheet('add')} color='grey'> Grey </Button>
                    <Button basic onClick={() => OpenBottomSheet('add')} color='black'> Black </Button> */}
                </div>
                <div className='col-12 col-lg-9'>
                    <div className='row'>
                        {
                            projectListe.map((data,index) => <div className='col-12 col-lg-4'>
                                <div className='card card-body shadow-sm border-div mb-3'>
                                    <h2 dir='rtl'> <NavLink to={`projectInfo/${data.P_ID}`}> {data.P_Name} </NavLink> <Button onClick={() => OpenBottomSheet('edit', data)}  icon circular size='mini' className='border-0 bg-white' ><Icon name='edit' /></Button> </h2>
                                    <hr />
                                     <div className='row'>
                                        <div className='col-6 align-self-center text-center'> <span className='mb-0 text-success'> + {data.P_Month_Income.toFixed(3)} </span><br /><span className='mt-0 text-danger'> - {data.P_Month_Cost.toFixed(3)} </span></div>
                                        <div className='col-6 align-self-center text-center'><span className='badge bg-warning mb-0'>{data.P_State}</span><br /><small className='mt-0'>{data.P_Start_Date}</small></div>
                                     </div>
                                </div>
                            </div>)
                        }
                        
                    </div>
                </div>
                <div className='col-12 col-lg-3'>
                    <div className='ps-4'>
                        <h1 className='text-start mb-2'>TOTALE  </h1>
                        
                        <h2 className='text-start mt-0 mb-1 text-primary' dir='ltr'>Month : {totaleMonth} </h2>
                        <h2 className='text-start mt-1 mb-1 text-info ' dir='ltr'>Year : {totalYear}  </h2>
                    </div>
                </div>
             </div>
            {/* <ul>
                <li><b>abyedh.com</b> : 5000dt/ans </li>
                <li><b>renting house</b> : 300dt/mois </li>
                <li><b>etude</b> : 150dt/mois</li>
                <li><b>vending machine</b> : 500dt/mois</li>
                <li><b>project agricole</b> :  1000dt/mois </li>
            </ul> */}
            <BottomSheet expandOnContentDrag open={openD}  onDismiss={() => setOpenD(!openD)}  >
                    <div className='card-body'>
                        { activeIndex =='add' ?   <AddCard /> : <></> }   
                        { activeIndex == 'edit' ?  <EditCard toEditProject={toEditProject} setToeditProject={setToeditProject}  /> : <></> }
                        {/* { activeIndex == 'language' ?  <LanguageCard /> : <></> }    */}
                    </div>
            </BottomSheet>
        </div>
    </> );
}

export default HoussemMainPage;